// import * as originPackageService from '../../../services/originPackage'

import * as companyService from "../../../services/company";
import * as customerBillService from "../../../services/customerBill";
import * as settings from "../../../services/settings";

import { ArrowLeftOutlined, DeleteOutlined, DownOutlined, EditOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
  notification,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { usePermission, useUser } from "../../../hooks/usePermission";

import AuthGroup from "../../../../configs/authgroup";
import { CustomerBiller } from "../../../Components/exportBillers/exportPDF/customerBiller";
import { CustomerBillerInvoice } from "../../../Components/exportBillers/exportPDF/customerBillerInvoice";
import { ModalDelete } from "../../../Components/model/modal/delete";
import dayjs from "dayjs";
import { formatNumber } from "../../../utils/number";
import permissions from "../../../../configs/permission";
import { useAccessToken } from "../../../contexts/AccessTokenContext";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { useTranslation } from "react-i18next";

const initPage = { limit: 10, page: 1 };
const { RangePicker } = DatePicker;
// let promise
export const CustomerBilPage = () => {
  const { hasPermission, isSuperuser, groups } = usePermission();
  const { accessToken } = useAccessToken();
  const { companyId: userCompanyId } = useUser();
  const isCompanySale = groups.includes(AuthGroup.CompanySale);
  const isCompanyOwner = groups.includes(AuthGroup.CompanyOwner);
  const hasFetchedRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation(["customerbill", "buttons", "common", "menus"]);
  const { t: tOps } = useTranslation("options", { keyPrefix: "Bill" });
  const [search, setSearch] = useState(initPage);
  const [customerBill, setCustomerBill] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isOpenButton, setIsOpenButton] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalInvoice, setIsOpenModalInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);
  //   const [ellipsis, setEllipsis] = useState(true)
  const [from] = Form.useForm();
  const [dateRange, setDateRange] = useState([]);
  const [countSelect, setCountSelect] = useState(0);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const EXPORT_ALL_MAX = 5000;
  const navigate = useNavigate();
  const { Title, Link } = Typography;
  const { Search } = Input;
  const [total, setTotal] = useState(0);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});

  const [tempSearch, setTempSearch] = useState();

  const defaultUserData = {
    company_id: userCompanyId,
  };

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (type, message, description) => {
      api[type]({ message, description });
    },
    [api]
  );

  const [companyList, setCompanyList] = useState([]);
  const [mappingCompanyId, setMappingCompanyId] = useState(userCompanyId);

  // Keep current language for tabs opened via direct URL.
  useEffect(() => {
    localStorage.setItem("lang", i18n.language);
  }, [i18n.language]);

  const onDeleteCustomerBill = async (data) => {
    let prepareDeleteOriginPackage = {
      id: data.id,
    };

    setLoading(true);
    try {
      const response = await customerBillService.deleteCustomerBill(accessToken, prepareDeleteOriginPackage);
      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        t("Success", { ns: "common" }),
        t("Delete_Success", { ns: "common" })
      );
      setPrepareDeleteData({});
      setIsOpenDelete(false);
      setLoading(false);
      fetchCustomerBill({ ...search });
    } catch (err) {
      console.error("[CustomerBilPage] onDeleteCustomerBill: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
      setLoading(false);
    }
  };

  // const fetchCustomerBill = useCallback(
  //   async (param, searchTerm) => {
  //     setLoading(true);
  //     try {
  //       console.log(location.state);
  //       if (location.state != undefined && location.state.originTransportationId.length > 0) {
  //         const queryParamString = location.state.originTransportationId.join(",");
  //         param.origin_transportation_id = queryParamString;
  //       }

  //       // Send the query parameter
  //       if (searchTerm) {
  //         param.origin_transportation_id = searchTerm;
  //       }

  //       const data = await customerBillService.getCustomerBill(accessToken, param);
  //       setTotal(data.totalCount);
  //       setCustomerBill(data.queryCustomerBill);
  //       setSearch({ ...param });
  //     } catch (err) {
  //       console.error("[CustomerBilPage] fetchCustomerBill: ", err);
  //       const { message } = settings.getErrorMessage(err);
  //       openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  //   [accessToken]
  // );

  const fetchCustomerBill = useCallback(async (params) => {
    setLoading(true);
    try {
      const data = await customerBillService.getCustomerBill(accessToken, params);
      setTotal(data.totalCount);
      setCustomerBill(data.queryCustomerBill);
      setSearch({ ...params });
    } catch (err) {
      console.error("[CustomerBilPage] fetchCustomerBill: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
    } finally {
      setLoading(false);
    }
  });

  const onSearch = async (value) => {
    const { search, search_date, bill_status, company_id, customer_id, ...data } = value;
    let start_date;
    let end_date;
    if (search_date) {
      start_date = dateRange[0] || undefined;
      end_date = dateRange[1] || undefined;
    }

    const params = {
      start_date: start_date,
      end_date: end_date,
      id: !isNaN(Number(search)) ? search : undefined,
      container: isNaN(Number(search)) ? search : undefined,
      bill_no: !isNaN(Number(search)) ? search : undefined,
      bill_status: normalizeSelection(bill_status),
      company_id: normalizeSelection(company_id),
      customer_id: normalizeSelection(customer_id),
    };

    setTempSearch(value);
    try {
      setLoading(true);
      await fetchCustomerBill({ ...params, page: value.page ?? initPage.page, limit: value.limit ?? initPage.limit }); // Assume this function fetches the data
    } catch (err) {
      console.error("[CustomerBilPage] onSearch: ", err);
    } finally {
      setLoading(false);
    }
  };

  const normalizeSelection = (values) => {
    const modify = values !== "all" ? values : undefined;
    return modify;
  };

  const getCompanyList = async () => {
    try {
      setLoading(true);
      const companyData = await companyService.getCompanysList(accessToken);
      setCompanyList(companyData);
    } catch (err) {
      console.error("[CustomerBilPage] fetch company list: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
    } finally {
      setLoading(false);
    }
  };

  const getCompanyById = useCallback(
    async (id) => {
      try {
        let companyList = [];
        setLoading(true);
        const data = await companyService.getCompanyById(accessToken, id);
        companyList.push(data);
        setCompanyList(companyList);
      } catch (err) {
        console.error("[CustomerPage] fetch company by id: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      } finally {
        setLoading(false);
      }
    },
    [accessToken]
  );

  const mappingSelectOption = async () => {
    if (isSuperuser || userCompanyId === null) {
      await getCompanyList();
    } else {
      await getCompanyById(userCompanyId);
    }
  };

  const optionCompanySelection = (companies = []) => {
    const hasMultiple = companies.length > 1;

    return [
      ...(hasMultiple
        ? [{ label: t("Search.All_Company", { defaultValue: "All Company" }), value: "all" }]
        : []),
      ...companies.map((item, index) => ({
        label: `${item.company_name} (${item.company_code})`,
        value: item.id,
        key: `company-${index}-${item.id}`,
      })),
    ];
  };

  const optionCustomerSelection = (companies = []) => {
    return [
      { label: t("Search.All_Customer", { defaultValue: "All Customer" }), value: "all" },
      ...companies
        .filter((company) => company.id === mappingCompanyId)
        .flatMap((company) =>
          (company.app_customer || []).map((customer, cIndex) => ({
            label: `${customer.id} (${customer.customer_name}-${customer.customer_code})`,
            value: customer.id,
            key: `customer-${cIndex}-${customer.id}`,
          }))
        ),
    ];
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const onFinish = async () => {
    const values = from.getFieldsValue();
    try {
      setLoading(true);
      await onSearch({ ...values, ...initPage });
    } finally {
      setLoading(false);
    }
  };

  const onReset = async () => {
    from.resetFields();

    try {
      setLoading(true);
      setCountSelect(0);
      await fetchCustomerBill({ ...defaultUserData, ...initPage });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!accessToken || hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    (async () => {
      await Promise.all([fetchCustomerBill({ ...defaultUserData, ...initPage }), mappingSelectOption()]);
    })();
  }, [accessToken]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, newSelectedRows) => {
      setIsSelectAll(false);
      setSelectedRows(newSelectedRows);
      setIsOpenButton(newSelectedRowKeys.length === 0);
      setSelectedRowKeys(newSelectedRowKeys);
      setCountSelect(newSelectedRowKeys?.length || 0);
    },
  };
  const handleItemClick = () => {
    setIsOpenModal(true);
    handlePrint();
  };

  const handleItemClickInvoice = async () => {
    const selectedCount = countSelect || selectedRowKeys?.length || 0;
    if (!selectedCount) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Please_Select_At_Least_One_Item", { ns: "common" }) || "Please select at least one item."
      );
      return;
    }
    setLoading(true);
    try {
      const data = await customerBillService.getCustomerBillInvoice(accessToken, selectedRowKeys);
      setInvoiceData(data ?? []);
      setIsOpenModalInvoice(true);
    } catch (err) {
      console.error("[CustomerBillPage] handleItemClickInvoice: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
    } finally {
      setLoading(false);
    }
  };

  const exportInvoiceExcel = async () => {
    const selectedCount = countSelect || selectedRowKeys?.length || 0;
    if (!selectedCount) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Please_Select_At_Least_One_Item", { ns: "common" }) || "Please select at least one item."
      );
      return;
    }
    setLoading(true);
    try {
      let response;
      if (isSelectAll) {
        // invoice export จำกัดที่ 10 bills ต่อครั้ง (โหลด image + render หนัก)
        const INVOICE_ALL_MAX = 10;
        const { page, limit, ...searchFilters } = search;
        const exportLimit = Math.min(selectedCount, INVOICE_ALL_MAX);
        if (selectedCount > INVOICE_ALL_MAX) {
          setCountSelect(INVOICE_ALL_MAX);
        }
        response = await customerBillService.exportCustomerBillInvoiceAll(accessToken, {
          ...searchFilters,
          page: 1,
          limit: exportLimit,
        });
      } else {
        response = await customerBillService.exportCustomerBillInvoice(accessToken, selectedRowKeys);
      }

      const contentDisposition = response.headers["content-disposition"] || "";
      const serverFilename = contentDisposition.match(/filename=([^\s;]+)/)?.[1];
      const contentType = response.headers["content-type"] || "";
      const isZip = contentType.includes("application/zip");
      const fallbackExt = isZip ? ".zip" : ".xlsx";
      const downloadFilename = serverFilename || `customer-invoice-${dayjs().format("YYYY-MM-DD-HHmm")}${fallbackExt}`;

      const blob = new Blob([response.data], { type: contentType || "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", downloadFilename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        t("Success", { ns: "common" }),
        t("Export_Success", { ns: "common" }) || "Export completed successfully."
      );
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
      console.error("[CustomerBilPage] exportInvoiceExcel: ", err);
    } finally {
      setLoading(false);
    }
  };

  const handleItemClickExport = () => {
    onExport();
  };

  const onExportReportSummary = async () => {
    const selectedCount = countSelect || selectedRowKeys?.length || 0;
    if (!selectedCount) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Please_Select_At_Least_One_Item", { ns: "common" }) || "Please select at least one item to export."
      );
      return;
    }
    if (selectedCount > EXPORT_ALL_MAX) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Export_All_Limit_Error", {
          ns: "error",
          max: EXPORT_ALL_MAX.toLocaleString(),
          count: selectedCount.toLocaleString(),
        })
      );
      return;
    }
    setLoading(true);
    try {
      let response;
      if (isSelectAll) {
        const { page, limit, ...searchFilters } = search;
        const exportLimit = Math.max(1, Math.min(Number(total) || selectedCount, selectedCount));
        response = await customerBillService.exportReportSummaryCustomerBillAll(accessToken, {
          ...searchFilters,
          page: 1,
          limit: exportLimit,
        });
      } else {
        response = await customerBillService.exportReportSummaryCustomerBill(accessToken, selectedRowKeys);
      }
      const contentDisposition = response.headers["content-disposition"] || "";
      const serverFilename = contentDisposition.match(/filename=([^\s;]+)/)?.[1];
      const contentType = response.headers["content-type"] || "";
      const isZip = contentType.includes("application/zip");
      const fallbackExt = isZip ? ".zip" : ".xlsx";
      const downloadFilename =
        serverFilename || `summary_customer_bill_${dayjs().format("YYYY_MM_DD_HHmmss")}${fallbackExt}`;

      const blob = new Blob([response.data], { type: contentType || "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", downloadFilename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        t("Success", { ns: "common" }),
        t("Export_Success", { ns: "common" }) || "Export completed successfully."
      );
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
      console.error("[CustomerBilPage] onExportReportSummary: ", err);
    } finally {
      setLoading(false);
    }
  };

  const onExport = async () => {
    const selectedCount = countSelect || selectedRowKeys?.length || 0;
    if (!selectedCount) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Please_Select_At_Least_One_Item", { ns: "common" }) || "Please select at least one item to export."
      );
      return;
    }
    if (selectedCount > EXPORT_ALL_MAX) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Export_All_Limit_Error", {
          ns: "error",
          max: EXPORT_ALL_MAX.toLocaleString(),
          count: selectedCount.toLocaleString(),
        })
      );
      setCountSelect(EXPORT_ALL_MAX);
      if (!isSelectAll && selectedRowKeys.length > EXPORT_ALL_MAX) {
        setSelectedRowKeys(selectedRowKeys.slice(0, EXPORT_ALL_MAX));
        setSelectedRows(selectedRows.slice(0, EXPORT_ALL_MAX));
      }
      return;
    }
    setLoading(true);
    try {
      let response;
      if (isSelectAll) {
        const { page, limit, ...searchFilters } = search;
        const selectedCount = countSelect || selectedRowKeys?.length || 0;
        const exportLimit = Math.max(1, Math.min(Number(total) || selectedCount, selectedCount));
        response = await customerBillService.exportCustomerBillAll(accessToken, {
          ...searchFilters,
          page: 1,
          limit: exportLimit,
        });
      } else {
        response = await customerBillService.exportCustomerBill(accessToken, { ids: selectedRowKeys });
      }
      const contentDisposition = response.headers["content-disposition"] || "";
      const serverFilename = contentDisposition.match(/filename=([^\s;]+)/)?.[1];
      const contentType = response.headers["content-type"] || "";
      const isZip = contentType.includes("application/zip");
      const fallbackExt = isZip ? ".zip" : ".xlsx";
      const downloadFilename =
        serverFilename || `customer-bill-export-${dayjs().format("YYYY-MM-DD-HHmm")}${fallbackExt}`;

      const blob = new Blob([response.data], { type: contentType || "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", downloadFilename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      setSelectedRowKeys([]);
      setSelectedRows([]);
      setIsSelectAll(false);
      setIsOpenButton(true);
      setCountSelect(0);
      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        t("Success", { ns: "common" }),
        t("Export_Success", { ns: "common" }) || "Export completed successfully."
      );
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
      console.error("[CustomerBilPage] onExport: ", err);
    } finally {
      setLoading(false);
    }
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleDateChange = (dates, dateStrings) => {
    setDateRange(dateStrings);
  };

  const disableFutureDates = (current) => {
    return current && current.isAfter(dayjs().endOf("day"));
  };

  const selectStatusBill = [
    { value: "all", label: t("Search.All_Status", { defaultValue: "All status" }) },
    { value: "PAID", label: tOps("Bill_Status.Paid") },
    { value: "UNPAID", label: tOps("Bill_Status.UnPaid") },
  ];

  const handleChangeCompany = (value, _) => {
    setMappingCompanyId(value);
  };
  const columns = [
    {
      title: t("Customer_Bill_Table.Table_Bill_No"),
      dataIndex: "bill_no",
      render: (_, record) => {
        if (!hasPermission(permissions.CustomerBill.VIEW)) {
          return <span style={{ color: "rgba(0, 0, 0, 0.45)" }}>{record.bill_no}</span>;
        }

        return (
          <RouterLink
            to={`/bill/customerbill/create?id=${record.id}&mode=edit`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            {record.bill_no}
          </RouterLink>
        );
      },
      // render: (_, record) => <p>{record.bill_no}</p>,
      // render: (_, record) => (
      //   <Button
      //     type="link"
      //     style={{ padding: 0 }}
      //     disabled={!hasPermission(permissions.CustomerBill.VIEW)}
      //     onClick={(e) => {
      //       e.stopPropagation();
      //       navigate("/bill/customerbill/create", {
      //         state: { type: "EDIT", data: record },
      //       });
      //     }}
      //   >
      //     {record.bill_no}
      //   </Button>
      // ),
    },
    {
      title: t("Customer_Bill_Table.Table_Bill_Status"),
      dataIndex: "bill_status",
    },
    {
      title: t("Customer_Bill_Table.Table_Origin_Transportation"),
      dataIndex: "container",
      render: (_, record) => {
        const containerName = record?.app_origintransportation?.container;
        return <>{containerName ?? "-"}</>;
      },
    },
    {
      title: t("Customer_Bill_Table.Table_Company"),
      dataIndex: "company_name",
      render: (_, record) => {
        const id = record?.app_company?.id;
        const companyName = record?.app_company?.company_name;
        const companyCode = record?.app_company?.company_code;
        return <p>{`${id ?? "-"}  ${companyName ?? "-"} (${companyCode ?? "-"})`}</p>;
      },
    },
    {
      title: t("Customer_Bill_Table.Table_Customer"),
      dataIndex: "customer_name",
      render: (_, record) => {
        const customerCode = record?.app_customer?.customer_code;
        const companyCode = record?.app_company?.company_code;
        const saleCode = record?.app_customer?.app_sale?.sale_code;
        return <p>{`${companyCode ?? "-"}-${saleCode ?? "-"}${customerCode ?? "-"}`}</p>;
      },
    },
    {
      title: t("Customer_Bill_Table.Table_Total_Volume"),
      dataIndex: "package_total_volume",
      render: (value) => formatNumber(value, 4, "round"),
    },
    {
      title: t("Customer_Bill_Table.Table_Gross_Weight"),
      dataIndex: "package_total_weight",
      render: (value) => formatNumber(value, 4, "round"),
    },
    {
      title: t("Customer_Bill_Table.Table_Total_Bill_Amount"),
      dataIndex: "package_total_bill_amount",
      render: (_, record) => formatNumber(record?.sum_total_bill ?? record?.package_total_bill_amount ?? 0, 4, "round"),
    },
    {
      title: t("Create_At", { ns: "common" }),
      dataIndex: "created_at",
      render: (_, record) => {
        const created_at = record.created_at != null ? dayjs(record.created_at).format("YYYY-MM-DD hh:mm:ss A") : "-";
        return <p>{created_at}</p>;
      },
    },
    {
      title: t("Update_At", { ns: "common" }),
      dataIndex: "updated_at",
      render: (_, record) => {
        const updated_at = record.updated_at != null ? dayjs(record.updated_at).format("YYYY-MM-DD hh:mm:ss A") : "-";
        return <p>{updated_at}</p>;
      },
    },
    {
      title: t("Edit", { ns: "common" }),
      key: "edit",
      width: 70,
      render: (_, row) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.CustomerBill.CHANGE)}
          onClick={(e) => {
            e.stopPropagation();
            navigate("/bill/customerbill/create", {
              state: { type: "EDIT", data: row },
            });
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },
    {
      title: t("Delete", { ns: "common" }),
      key: "delete",
      width: 70,
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.CustomerBill.DELETE)}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpenDelete(true);
            setPrepareDeleteData(record);
          }}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  const items = [
    { title: t("Page_Body_Tab_Menu.Home", { ns: "menus" }) },
    { title: t("Page_Body_Tab_Menu.Menu", { ns: "menus" }) },
    {
      title: (
        <a href="/bill/customerbill" style={{ fontWeight: 600, color: "black" }}>
          {t("Title_Customer_Bill")}
        </a>
      ),
    },
  ];

  const onSelectAll = () => {
    if (total > EXPORT_ALL_MAX) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Export_All_Limit_Error", {
          ns: "error",
          max: EXPORT_ALL_MAX.toLocaleString(),
          count: total.toLocaleString(),
        })
      );
      setSelectedRowKeys([]);
      setSelectedRows([]);
      setIsSelectAll(true);
      setCountSelect(EXPORT_ALL_MAX);
      setIsOpenButton(false);
      return;
    }
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setIsSelectAll(true);
    setCountSelect(total);
    setIsOpenButton(false);
  };

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        {isOpenModal && hasPermission(permissions.CustomerBill.EXPORT) ? (
          <CustomerBiller setIsOpenModal={setIsOpenModal} isOpenModal={isOpenModal} data={selectedRows} />
        ) : null}
        {isOpenModalInvoice && hasPermission(permissions.CompanyBill.PRINT_INVOICE) ? (
          <CustomerBillerInvoice
            setIsOpenModal={setIsOpenModalInvoice}
            isOpenModal={isOpenModalInvoice}
            data={invoiceData}
          />
        ) : null}

        <Row flex={1}>
          <Col span={24}>
            <Breadcrumb items={items} />
            <Row style={{ padding: "15px 0px" }}>
              <Col span={24}>
                <Title level={4} style={{ textWrap: "nowrap", display: "flex", gap: "7px" }}>
                  <ArrowLeftOutlined style={{ fontSize: "20px" }} />
                  {t("Title_Customer_Bill")}
                </Title>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Form Search */}
        <Row style={{ display: "flex", justifyContent: "left", overflowX: "auto" }}>
          <Col span={12}>
            <Form
              form={from}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              labelAlign="left"
              layout="horizontal"
              onFinish={onFinish}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  from.submit();
                }
              }}
              initialValues={{
                search_date: [dayjs().startOf("day"), dayjs().endOf("day")], // Set initial value for the date range
                search: undefined, // Initial value for search
                bill_status: "all", // Initial value for package status
                company_id: userCompanyId ? userCompanyId : "all", // Initial value for origin
                customer_id: "all", // Initial value for customer
              }}
            >
              <Row flex={1}>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Form.Item label={t("Create_At", { ns: "common" })} name="search_date">
                    <RangePicker
                      allowEmpty
                      style={{ width: "100%", minWidth: 200 }}
                      onChange={handleDateChange}
                      disabledDate={disableFutureDates}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Form.Item label={t("Search", { ns: "common" })} name="search">
                    <Input
                      size="default"
                      placeholder={t("Search.Placeholder_Id_Bill_No_Origin_Transportation", {
                        defaultValue: "Id / Bill No/ Origin Transportation",
                      })}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Form.Item label={t("Search.Bill_Status")} name="bill_status">
                    <Select
                      placeholder={t("Please_Select", { ns: "common" })}
                      options={selectStatusBill}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Form.Item label={t("Search.Company")} name="company_id" key="company_id">
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      showSearch
                      placeholder={t("Please_Select", { ns: "common" })}
                      options={optionCompanySelection(companyList)}
                      filterOption={filterOption}
                      onSelect={handleChangeCompany}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Form.Item label={t("Search.Customer")} name="customer_id" key="customer_id">
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      showSearch
                      placeholder={t("Please_Select", { ns: "common" })}
                      allowClear
                      // loading={customerListLoading}
                      // disabled={customerListLoading}
                      options={optionCustomerSelection(companyList)}
                      filterOption={filterOption}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="end" align="middle">
                <Col span={24} style={{ textAlign: "end" }}>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} disabled={loading}>
                      {t("BTN_Search", { ns: "buttons" })}
                    </Button>
                    <Button type="default" onClick={() => onReset()} style={{ marginLeft: "5px" }} disabled={loading}>
                      {t("BTN_Reset", { ns: "buttons" })}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        <Row align="middle" justify="end">
          <Col
            span={24}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "1rem",
            }}
          >
            <Space direction="inline">
              {hasPermission(permissions.CustomerBill.PRINT_INVOICE) && (
                <Dropdown
                  disabled={isOpenButton}
                  menu={{
                    items: [
                      {
                        key: "pdf",
                        label: t("File_Type.PDF", { ns: "common", defaultValue: "PDF" }),
                        onClick: handleItemClickInvoice,
                      },
                      {
                        key: "excel",
                        label: t("File_Type.Excel", { ns: "common", defaultValue: "Excel" }),
                        onClick: exportInvoiceExcel,
                      },
                    ],
                  }}
                  placement="bottomLeft"
                >
                  <Button type="primary" disabled={isOpenButton}>
                    <Space>
                      {t("Button_Customer_Bill.BTN_Print_Invoice")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              )}
              {hasPermission(permissions.CustomerBill.PRINT) && (
                <Button
                  disabled={isOpenButton}
                  type="primary"
                  onClick={() => {
                    handleItemClick();
                  }}
                >
                  {t("Button_Customer_Bill.BTN_Print")}
                </Button>
              )}
              {hasPermission(permissions.CustomerBill.EXPORT) && (
                <Button
                  disabled={isOpenButton}
                  type="primary"
                  onClick={() => {
                    handleItemClickExport();
                  }}
                >
                  {t("Button_Customer_Bill.BTN_Export")}
                </Button>
              )}
              {hasPermission(permissions.CustomerBill.EXPORT_REPORT_SUMMARY) && (
                <Button disabled={isOpenButton} type="primary" onClick={onExportReportSummary}>
                  {t("Button_Customer_Bill.BTN_Report_Summary")}
                </Button>
              )}
            </Space>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col span={24}>
            {`${t("Select", { ns: "common" })}: ${countSelect} to ${total}`}&nbsp;
            <Link onClick={onSelectAll} target="_blank">
              {t("Select_All", { ns: "common" })}
            </Link>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col span={24}>
            <Card>
              <Table
                loading={loading}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={customerBill}
                scroll={{ x: "max-content" }}
                rowKey={(record) => record.id}
                pagination={{
                  defaultPageSize: search.limit,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  current: search.page,
                  pageSize: search.limit,
                  total: total,
                  onChange: (page, limit) => {
                    onSearch({ ...tempSearch, page, limit });
                  },
                  showSizeChanger: true,
                }}
                style={{ cursor: "pointer" }}
                // onRow={(record) => ({
                //   onClick: (event) => {
                //     // กรณีไม่อยากให้คลิกแถวแล้วไปที่หน้าสร้างถ้ามีปุ่มอื่น ให้ filter ด้วย event.target
                //     navigate("/bill/customerbill/create", {
                //       state: { type: "EDIT", data: record },
                //     });
                //   },
                // })}
              />
            </Card>
          </Col>
          {/* <ModalsCustomerBiller
            isOpenModal={isOpenModal}
            setIsOpenModal={setIsOpenModal}
            handlePrint={handlePrint}
            data={selectedRows}
            ref={componentRef}
          /> */}
        </Row>
        <ModalDelete
          isOpen={isOpenDelete}
          handleCloseModal={() => {
            setIsOpenDelete(false);
          }}
          onClick={() => {
            onDeleteCustomerBill(prepareDeleteData);
          }}
          dataDetail={prepareDeleteData}
          t={t}
        />
      </Spin>
    </>
  );
};
